export const DELIVERIES_TABLE_GRID_COLUMNS = 'repeat(8, minmax(0, 1fr))';
